import { useContext, useEffect, useState } from 'react'

import { Wrapper } from 'components'
import { TrainingItem } from 'api/types/trainings'
import { trainingService } from 'api/services/trainings'
import { format } from 'date-fns'
import {
  Badge,
  Button,
  Card,
  Spinner,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  toast,
} from 'keep-react'
import { AuthContext } from 'contexts/AuthContext'
import { RouteNamesAuth } from 'routes/enum'
import { Link } from 'react-router-dom'

// form validation schema

export const Trainings = () => {
  //first load and is api being called
  const { currentUser } = useContext(AuthContext)
  const { Birthdate, Name, IdCard, IdCardExpiracy, Email } = currentUser || {}

  const [validUserProfile, setValidUserProfile] = useState<boolean>(true)

  const [isLoading, setIsLoading] = useState<boolean>(false)

  // trainings data
  const [data, setData] = useState<TrainingItem[] | null>(null)

  // fetch training list from API
  const getTrainingList = async () => {
    setIsLoading(true)
    try {
      const response = (await trainingService.getTrainingList({
        trainingStatus: '1',
      })) as TrainingItem[]
      setData(response || [])
      setIsLoading(false)
    } catch (error) {
      toast.error('Não foi possível carregar as formações.')
    }
  }

  // Implement registration logic here
  const handleRegistration = async (confId: string) => {
    try {
      await trainingService.registerForTraining({
        conferenceId: confId,
        email: Email as string,
        firstName: Name!.split(' ')[0] as string,
        lastName: Name!.split(' ')[1] as string,
      })
      toast.success('Inscrição na formação efetuada com sucesso!')
    } catch (error) {
      toast.error('Não foi possível efectuar a inscrição na formação.')
    }
  }

  useEffect(() => {
    if (
      Birthdate?.trim() &&
      Name?.trim() &&
      IdCard?.trim() &&
      IdCardExpiracy?.trim()
    ) {
      setValidUserProfile(true)
    } else {
      setValidUserProfile(false)
    }
  }, [currentUser])

  // initial data fetch
  useEffect(() => {
    getTrainingList()
  }, [])

  return (
    <div className="w-full flex-1 py-12 overflow-auto">
      <Wrapper>
        <h1 className="pb-10 text-xxxl font-medium text-primary-600 flex items-center justify-between">
          <span>Formações a decorrer</span>
        </h1>

        {isLoading || !data ? (
          <Card className="p-4 w-full max-w-full">
            <Spinner color="primary" className="mx-auto" />
          </Card>
        ) : (
          <>
            {!validUserProfile && (
              <div className="text-body-4 mb-4 bg-metal-900 rounded-lg text-white p-4 space-y-4">
                <p>
                  <strong className="text-primary-300 uppercase">Nota:</strong>{' '}
                  para se poder inscrever precisa que o seu perfil esteja
                  actualizado. Nome, data de nascimento, nº de cartão de cidadão
                  e data de validade do mesmo são obrigatórios.{' '}
                </p>
                <p>
                  <Button
                    color="primary"
                    variant="outline"
                    className="border-primary-300 text-primary-300"
                  >
                    <Link to={RouteNamesAuth.PROFILE}>Atualizar perfil</Link>
                  </Button>
                </p>
              </div>
            )}
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Nome</TableHead>
                  <TableHead>Data/Hora</TableHead>
                  <TableHead>Formador</TableHead>
                  <TableHead></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data &&
                  data.map(
                    (training: TrainingItem, index: number) =>
                      training.status &&
                      !training.tutorial && (
                        <TableRow
                          key={`${training.id}-${index}`}
                          className="even:bg-primary-50/25"
                        >
                          <TableCell className="normal-case">
                            {training.name}
                          </TableCell>

                          <TableCell className="normal-case whitespace-nowrap">
                            {format(
                              new Date(training.date ?? new Date()),
                              'dd/MM/yyyy HH:mm',
                            )}
                          </TableCell>

                          <TableCell className="normal-case">
                            {training.teacher}
                          </TableCell>

                          <TableCell className="normal-case">
                            {training.isUserRegistered && training.link && (
                              <Button
                                color="primary"
                                variant="softBg"
                                className="normal-case"
                                disabled={
                                  !validUserProfile || !training.conferenceId
                                }
                              >
                                Ir para a formação
                              </Button>
                            )}

                            {training.isUserRegistered && !training.link && (
                              <Badge
                                color="secondary"
                                variant="base"
                                className="px-4 py-2 text-body-4 pointer-events-none normal-case"
                              >
                                Já se inscreveu!
                              </Badge>
                            )}

                            {!training.isUserRegistered && (
                              <Button
                                color="primary"
                                variant="softBg"
                                disabled={
                                  !validUserProfile || !training.conferenceId
                                }
                                onClick={() =>
                                  handleRegistration(training.conferenceId!)
                                }
                              >
                                inscrever agora
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      ),
                  )}
              </TableBody>
            </Table>
          </>
        )}
      </Wrapper>
    </div>
  )
}
